export enum Amenity {
	Local = 'CLT Local',
	Vegan = 'vegan',
	GlutenFree = 'gluten free',
	Vegetarian = 'vegetarian',
	MobileOrdering = 'mobile ordering',
}

export function isAmenity(input: string): input is Amenity {
	return Object.values(Amenity).includes(input as Amenity);
}
